import React, { Suspense } from 'react';
import reportWebVitals from './reportWebVitals';
import {App} from "./App";
import './assets/bootstrap/bootstrap.scss';
import "./i18n";
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Suspense fallback="loading">
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
